import { render } from "./PreventiveDentistry.vue?vue&type=template&id=5429468d&scoped=true"
import script from "./PreventiveDentistry.vue?vue&type=script&lang=js"
export * from "./PreventiveDentistry.vue?vue&type=script&lang=js"

import "./PreventiveDentistry.vue?vue&type=style&index=0&id=5429468d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5429468d"]])

export default __exports__